<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/wVhth7/tc-custom/9780814794920.jpg?1719927354475" alt="This image is the cover for the book Feminist Nightmares: Women At Odds"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Feminist Nightmares: Women At Odds
      </h1>
      <p class="bookDescription body article font2">
        <p>Though all women are women, no woman is only a woman, wrote Elizabeth Spelman in <i>The Inessential Woman</i>.  Gone are the days when feminism translated simply into the advocacy of equality for women.  Women's interests are not always aligned; race, class, and sexuality complicate the equation.  In recent years, feminist ideologies have become increasingly diverse. Today, one feminist's most ardent political opponent may well be another feminist. As feminism grows increasingly diverse, the time has come to ask a painful and frequently avoided question:  what does it mean for women to oppress women?<br/> This pathbreaking, provocative anthology addresses this troublesome dilemma from various feminist perspectives, offering an interdisciplinary collection of writings that widens our understanding of oppression to take into account women who are at odds.  The book examines the social, political, and psychological ramifications of this phenomenon, as evidenced in a range of texts, from women's antislavery writing to women's anti-abortion writing, from mother-daughter incest stories to maternal surrogacy narratives, from the Bible to the popular romance nove, from Jane Austen to Alice Walker.<br/> The value of the volume is perhaps best summed up by an early response to the ideaThis is a book that should never be written; feminists should concentrate on how men oppress women.  Ironically, it is precisely because the subject triggers such responses, the authors argue, that a volume such as <i>Feminist Nightmares</i> has become a necessity.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susan Ostrov Weisser
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      New York University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cc526e7a